export default __webpack_public_path__ + "static/media/idtrust.e70d091c.png";